<span
  class="flex h-16 w-16 items-center justify-center rounded-full"
  [class]="partial() ? 'bg-orange-50 text-orange-700' : 'bg-main-light text-main'">
  <svg class="h-9 w-9" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
  </svg>
</span>

<div>
  <h2 class="text-base font-semibold" [class]="partial() ? 'text-orange-800' : 'text-main'">
    {{ title() }}
  </h2>
  @if (subtitle(); as subtitle) {
    <p class="mt-1 text-sm text-cmi-gray-mid">{{ subtitle }}</p>
  }
</div>
